import React, { useState } from "react";
import { FormattedMessage } from 'react-intl'
import { Modal, Backdrop, Grow } from '@material-ui/core'
import swal from 'sweetalert'
import Config from '../../commons/config/Config.js'
import PersonasImportar from './PersonasImportar'


const PersonasGridImport = (props) => {
  const intl = props.intl;
  const setModalImport = props.setModalImport;

  const [erroresModal, setErroresModal] = useState(false);
  const [erroresPorHoja, setErroresPorHoja] = useState({});
  const [advertenciasImportacion, setAdvertenciasImportacion] = useState([]);
  const [statsImportacion, setStatsImportacion] = useState(null);

  const agruparPorHoja = (errores) => {
    var grupos = {};
    errores.forEach(function(e) {
      var hoja = e.hoja || 'personas';
      if (!grupos[hoja]) grupos[hoja] = [];
      grupos[hoja].push({
        fila:    e.fila    || '',
        persona: e.nombre && e.apellido
          ? (e.nombre + ' ' + e.apellido).trim()
          : (e.nombre || e.apellido || ''),
        error:   e.error || ''
      });
    });
    return grupos;
  };

  const handleCancelModal = () => {
    setModalImport(false);
  };

  const handleCloseModal = (message, resultado, error) => {
    setModalImport(false);

    if (error) {
      if (error.codigo === 4010) {
        swal(
          intl.formatMessage({ id: 'personasGrid.alert.sesion_expiro', defaultMessage: 'La sesión expiró' }),
          intl.formatMessage({ id: 'personasGrid.alert.ingrese_nuevamente', defaultMessage: 'Por favor, ingrese nuevamente.' }),
          "error"
        ).then(() => { window.location.reload(); });
      } else {
        const detalle = error && error.detalle && Array.isArray(error.detalle) ? error.detalle : [];
        var erroresRaw = [];

        if (detalle.length > 0 && detalle.length % 4 === 0) {
          // formato aplanado: [fila, columna, error_key, detalle_text, ...]
          for (var i = 0; i < detalle.length; i += 4) {
            erroresRaw.push({
              hoja:     'personas',
              fila:     detalle[i],
              nombre:   detalle[i + 1],
              apellido: '',
              error:    detalle[i + 3]
            });
          }
        } else if (detalle.length > 0) {
          erroresRaw.push({ hoja: 'personas', fila: '', nombre: '', apellido: '', error: detalle.join(', ') });
        } else {
          erroresRaw.push({ hoja: 'personas', fila: '', nombre: '', apellido: '', error: message });
        }

        setErroresPorHoja(agruparPorHoja(erroresRaw));
        setAdvertenciasImportacion([]);
        setStatsImportacion(null);
        setErroresModal(true);
      }
      return;
    }

    if (resultado && resultado.errores && resultado.errores.length > 0) {
      setErroresPorHoja(agruparPorHoja(resultado.errores));
      setAdvertenciasImportacion(resultado.advertencias || []);
      setStatsImportacion(resultado.stats || null);
      setErroresModal(true);
    } else {
      const stats = resultado && resultado.stats ? resultado.stats : {};
      const statsText = [
        intl.formatMessage({ id: 'personasGrid.import.stats.procesadas', defaultMessage: 'Personas procesadas' }) + ': ' + (stats.personas_procesadas || 0),
        intl.formatMessage({ id: 'personasGrid.import.stats.creadas', defaultMessage: 'Creadas' }) + ': ' + (stats.personas_creadas || 0),
        intl.formatMessage({ id: 'personasGrid.import.stats.reutilizadas', defaultMessage: 'Reutilizadas' }) + ': ' + (stats.personas_reutilizadas || 0),
        intl.formatMessage({ id: 'personasGrid.import.stats.usuarios_creados', defaultMessage: 'Usuarios creados' }) + ': ' + (stats.usuarios_creados || 0),
      ].join('\n');
      swal(message, statsText, "success").then(() => {
        props.setStateImport();
      });
    }
  };

  const handleErroresCloseModal = () => {
    setErroresModal(false);
    setErroresPorHoja({});
    props.setStateImport();
  };

  const handleExportarErrores = () => {
    var filas = [];
    Object.keys(erroresPorHoja).forEach(function(hoja) {
      erroresPorHoja[hoja].forEach(function(err) {
        filas.push({ pagina: hoja, fila: err.fila, persona: err.persona, error: err.error });
      });
    });

    if (advertenciasImportacion.length > 0) {
      advertenciasImportacion.forEach(function(adv) {
        filas.push({ pagina: 'advertencias', fila: '', persona: (adv.nombre + ' ' + adv.apellido).trim(), error: adv.detalle });
      });
    }

    fetch(Config.get('apiUrlBase') + '/personas/exportar-errores-importacion', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token')
      },
      body: JSON.stringify({ filas: filas })
    })
      .then(function(response) { return response.blob(); })
      .then(function(blob) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'errores_importacion_personas.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      });
  };

  const todasLasHojas = Object.keys(erroresPorHoja);

  return (
    <>
      <Modal
        open={props.openImport}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 1000 }}
      >
        <Grow in={props.openImport}>
          <div className="col-8" tabIndex="-1" role="dialog" aria-labelledby="personasImportLabel" style={{ margin: "auto" }}>
            <div className="modal-xl modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header bg-fleet">
                  <h4 className="modal-title text-white" id="personasImportLabel">
                    <FormattedMessage id="personasGrid.tools.import.button.importar" defaultMessage=" Importar Personas"/>
                  </h4>
                  <button type="button" className="close" onClick={handleCancelModal} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body modal-grey">
                  <form className="form">
                    <PersonasImportar callbackClose={handleCloseModal} callbackCancel={handleCancelModal}/>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Grow>
      </Modal>

      <Modal
        open={erroresModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 1000 }}
      >
        <Grow in={erroresModal}>
          <div className="col-10" tabIndex="-1" role="dialog" aria-labelledby="personasImportErroresLabel" style={{ margin: "auto" }}>
            <div className="modal-lg modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header bg-fleet">
                  <h4 className="modal-title text-white" id="personasImportErroresLabel">
                    <FormattedMessage id="personasGrid.import.errores.titulo" defaultMessage="Errores en la Importación"/>
                  </h4>
                  <button type="button" className="close" onClick={handleErroresCloseModal} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body modal-grey modal-mh ovf-x-hidden">
                  <div className="card pull-up">
                    <div className="card-content pl-1 pr-1">
                      <div className="card-body form">
                        {statsImportacion && (
                          <div className="alert alert-info small mb-2">
                            <FormattedMessage id="personasGrid.import.stats.procesadas" defaultMessage="Personas procesadas"/>: {statsImportacion.personas_procesadas} &nbsp;|&nbsp;
                            <FormattedMessage id="personasGrid.import.stats.creadas" defaultMessage="Creadas"/>: {statsImportacion.personas_creadas} &nbsp;|&nbsp;
                            <FormattedMessage id="personasGrid.import.stats.reutilizadas" defaultMessage="Reutilizadas"/>: {statsImportacion.personas_reutilizadas} &nbsp;|&nbsp;
                            <FormattedMessage id="personasGrid.import.stats.usuarios_creados" defaultMessage="Usuarios creados"/>: {statsImportacion.usuarios_creados || 0}
                          </div>
                        )}
                        {todasLasHojas.map(function(hoja) {
                          return (
                            <div key={hoja} className="row mt-2">
                              <div className="col-12">
                                <h4 className="form-section">
                                  <FormattedMessage id="personasGrid.import.errores.pagina" defaultMessage="Página"/>: {hoja}
                                </h4>
                                <div className="table-responsive">
                                  <table className="table dataTable nowrap table-hover" width="100%">
                                    <thead>
                                      <tr>
                                        <th><FormattedMessage id="personasGrid.import.errores.columna_fila"         defaultMessage="Fila"/></th>
                                        <th><FormattedMessage id="personasGrid.import.errores.columna_persona"      defaultMessage="Persona"/></th>
                                        <th><FormattedMessage id="personasGrid.import.errores.columna_motivo_falla" defaultMessage="Motivo Falla"/></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {erroresPorHoja[hoja].map(function(err, i) {
                                        return (
                                          <tr key={i}>
                                            <td>{err.fila}</td>
                                            <td>{err.persona}</td>
                                            <td className="text-danger">{err.error}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        {advertenciasImportacion.length > 0 && (
                          <details className="mt-2">
                            <summary className="small text-muted">
                              <FormattedMessage id="personasGrid.import.advertencias.titulo" defaultMessage="Advertencias"/> ({advertenciasImportacion.length})
                            </summary>
                            <ul className="small mt-1">
                              {advertenciasImportacion.map(function(adv, i) {
                                return <li key={i}>{adv.nombre} {adv.apellido}: {adv.detalle}</li>;
                              })}
                            </ul>
                          </details>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer modal-grey">
                  <button type="button" className="btn btn-default btn-outline-secondary" onClick={handleExportarErrores}>
                    <i className="fa fa-download"></i>&nbsp;
                    <FormattedMessage id="personasGrid.import.errores.exportar" defaultMessage="Exportar"/>
                  </button>
                  <button type="button" className="btn btn-default btn-fleet" onClick={handleErroresCloseModal}>Ok</button>
                </div>
              </div>
            </div>
          </div>
        </Grow>
      </Modal>
    </>
  );
};

export default PersonasGridImport;
